<template>
	<center>
		<div class="gallery">
			<div v-for="(img,i) in imgs" v-bind:class="(i == 0) ? 'g-img-cont active' : 'g-img-cont'" v-bind:id="'gal-' + i" v-bind:key="'gal-' + i">
				<img class="g-img-display" @click="imgDispClickE" v-bind:src="img.url">
				<div class="g-description">{{img.description}}</div>
			</div>
			<div class="g-img-selectors">
				<div v-on:click="imgSelClickE(i)" v-for="(img,i) in imgs" v-bind:class="(i == 0) ? 'g-img-sel active' : 'g-img-sel'" v-bind:id="'gal2-' + i" v-bind:key="'gal2-' + i">
					<img v-bind:src="img.url">
				</div>
			</div>
		</div>
	</center>
</template>

<script type="text/javascript">
	import { ajaxGet,ajaxPost } from "../../../ajax";
  import {apiUrl} from "@/main";

	export default{
		data: function(){
			return {
				imgs:[],
				galleryId: undefined,
				dDisp: true
			}
		},
		created(){
			//populate data before every thing
			this.galleryId = this.$router.history.current.params.galleryId;
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            if(this.galleryId == 'undefined') alert("Not part of assignment.");
            ajaxGet(apiUrl() +"/"+assignmentFlag+"/" + this.galleryId,
				(dat) => {
					//on success dat is called
					if(dat.component == "gallery"){
						//This is the right component
						this.imgs = dat.data;
						this.isAnswered = dat.answers;
                    	window.document.title = dat.title
                    	//----------------------------------------------------------
						if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
							ajaxPost(apiUrl() +"/assignments/" + this.galleryId, {
							Data: {
								seen: Date.now()
							}
						},
						(suc) => {
							console.log("Posted assignment:", suc);
						},
						(err) => {
							console.log("Error :", err)
						}, localStorage.token);
						}
						//----------------------------------------------------------
					}else{
						//Wrong component type
						console.error("DATA MISMATCH on api call expected 'GALLERY' object, got '" + dat.component.toUpperCase() + "' object.");
					}
				},(err) => {
					//There was some error
					console.log(err);
				}, localStorage.token);
		},
		mounted(){
		},
		methods: {
			imgSelClickE(ec){
      //   let id = null;
      //   if(ec){
      //     if(ec.toElement){
      //       if(ec.toElement.parentElement){
      //         id = ec.toElement.parentElement.getAttribute("id");
      //       }
      //     }
      //   }
      //  
			// //	var id = ec.toElement.parentElement.getAttribute("id");
			// 	if(id == null && ec != null) {
      //     if(ec.toElement){
      //       id = ec.toElement.getAttribute("id");  
      //     }
      //    
      //   }
				document.querySelectorAll(".g-img-cont").forEach((e1) => {
					e1.classList.remove("active");
				});
				document.querySelectorAll(".g-img-sel").forEach((e1) => {
					e1.classList.remove("active");
				});
				document.querySelectorAll("#gal-" + ec).forEach((e1) => {
					e1.classList.add("active");
				});
			},
			imgDispClickE(ec){
				if(this.dDisp){
					//Hide the thingies
					this.dDisp = false;
					document.querySelectorAll(".g-description").forEach((e1) => {
						e1.style.display = "none";
					});
					document.querySelector(".g-img-selectors").style.display = "none";
				}else{
					//Show the elements
					this.dDisp = true;
					document.querySelectorAll(".g-description").forEach((e1) => {
						e1.style.display = "block";
					});
					document.querySelector(".g-img-selectors").style.display = "flex";
				}
			}
		}
	}
</script>
<style scoped>
	.gallery{
	    position: relative;
	    top: 0px;
	    width: 100%;
	    height: 100vh;
	    max-width: 100%;
	    max-height: 100vh;
	    overflow: auto;
	    display:flex;
	    align-items: center;
	    flex-direction: column;
		background: #000000; /* Old browsers */
		background: -moz-linear-gradient(45deg, #000000 0%, #45484d 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(45deg, #000000 0%,#45484d 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(45deg, #000000 0%,#45484d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#45484d',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
	}
	.g-img-cont{
		position: absolute;
		width: 100%;
		height: 100%;
		opacity: 0;
		transition: all 1s ease;  /* CHANGE THE TRANSITION TIME FOR GALLERY IN HERE!!! */
	}
	.g-img-cont > img{
		width: 100%;
		height: 100%;
		object-fit: contain;
		padding-top: 56px;
	}
	.g-img-cont.active{
		opacity: 1;
	}
	.g-img-cont .g-description{
		overflow: auto;
		position: absolute;
		left: 0;
		bottom: 100px;
		width: 100%;
		font-weight: 600;
		-webkit-text-stroke: 0.5px black;
		color: white;	
		font-size: 1.2em;
		background: #000a;
	}
	.g-img-selectors{
		width: 100%;
		height: 100px;
		position: absolute;
		bottom: 0;
		left: 0;
		background: #000a;
		display: flex;
		flex-direction: row;
		justify-content: center;
		cursor: pointer;
		align-items: center;
	}
	.g-img-selectors img{
		height: 95px;
		border: 2px solid black;
		margin: 0 10px;
		filter: brightness(50%);
		transition: all 0.5s ease;
	}
	.g-img-selectors img:hover{
		filter: brightness(65%);
	}
	.g-img-sel.active img{
		border: 2px solid green;
		filter: brightness(100%); 
	}
</style>